import { render, staticRenderFns } from "./ResetPassword.html?vue&type=template&id=1dd44d74&scoped=true&external"
import script from "./ResetPassword.js?vue&type=script&lang=js&external"
export * from "./ResetPassword.js?vue&type=script&lang=js&external"
import style0 from "./ResetPassword.scss?vue&type=style&index=0&id=1dd44d74&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd44d74",
  null
  
)

export default component.exports